import { render, staticRenderFns } from "./ExternalMailEvents.vue?vue&type=template&id=6903a3e6&"
import script from "./ExternalMailEvents.vue?vue&type=script&lang=js&"
export * from "./ExternalMailEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports